export const SEARCH_INPUT_FOCUS_KEY = 'SEARCH_INPUT';

export const getSearchHistoryRemoveFocusKey = (contentId: number) =>
  `SEARCH_HISTORY_REMOVE_${contentId}`;
